import React, { useEffect, useState, useCallback } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import ApiService2 from '../../../POS/services/apiService';
import ApiService from '../../services/apiService';
import InvoiceItemList from './invoiceItems';
import InvoiceGrnList from './invoiceGrntable';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthorizationInvoice from './invoiceAuthorization';
import { useSelector } from 'react-redux';
import { getCompany, getName, getUserId, getUserName } from '../../../Redux/selecters';
import { RiRefreshLine } from "react-icons/ri";
import { FaAngleLeft } from "react-icons/fa6";
import { FaSave } from "react-icons/fa";
import { ClipLoader } from 'react-spinners';
import Modal from 'react-bootstrap/Modal';
import Attachment from '../Attachment/attachment';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';

const createEmptyRow = () => ({
    id: Date.now() + Math.random(),
    file: null,
    fileName: "",
    remarks: "",
});
const UpdateInvoice = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [gridVisibility, setGridVisibility] = useState([true, false, false]);
    const apiService = new ApiService();
    const REPORT_URL = process.env.REACT_APP_REPORTS_URL
    const [messageData, setMessageData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [authorizationData, setAuthorizationData] = useState([]);
    const [ItemData, setItemData] = useState([]);
    const [GrnItemData, setGrnItems] = useState([]);
    const [grnData, setGrnData] = useState([]);
    const { currencyPrecision } = useCurrency();
    const [grnMainList, setGrnList] = useState([]);
    const [selectedGrn, setSelectedGrn] = useState();
    const [SelectedCurrency, setSelectedCurency] = useState([]);
    const [POData, setPOData] = useState([]);
    const [usersDetails, setUser] = useState([]);
    const [PurchaseOrder, setPurchaseOrder] = useState([]);
    const [SelectedPO, setSelectedPO] = useState([]);
    const [invoiceNo, setInvoiceNo] = useState([]);
    const [SelectedSupplier, setSelectedSupplier] = useState([]);
    const userId = useSelector(getUserId);
    const userName = useSelector(getUserName);
    const Company = useSelector(getCompany);
    const currentDatetimeUTC = new Date().toISOString().slice(0, 16);
    const todayDate = new Date().toISOString().substr(0, 10);
    const [SupplierTab, setSupplierTab] = useState(true);
    const [POTab, setPOTab] = useState(true);
    const [CostTab, setCostTab] = useState(false);
    const [loading, setLoading] = useState(false);
    const [cost1, setCost1] = useState([]);
    const [cost2, setCost2] = useState([]);
    const [cost3, setCost3] = useState([]);
    const [cost4, setCost4] = useState([]);
    const [docModal, setDocModal] = useState(false);
    const onOpenModal = () => setDocModal(true);
    const onCloseModal = () => setDocModal(false);


    // Attachment
    const [attachmentModal, setAttachmentModal] = useState(false);
    const [previewModal, setPreviewModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [attachments, setAttachments] = useState([createEmptyRow()]);
    const handleOpen = () => setAttachmentModal(true);
    const closeModal = () => setAttachmentModal(false);
    const isReadOnly = false;
    const location = useLocation();
    const itemData = location.state;
    const [overallDiscount, setOverallDiscount] = useState(0);
    const [discountAmount, setDiscountAmount] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);
    const [vatAmount, setVatAmount] = useState(0);

    const getCurrentLocalDatetime = () => {
        const localDate = new Date();
        const offset = localDate.getTimezoneOffset() * 60000;
        const localISOTime = new Date(localDate - offset).toISOString().slice(0, 16);
        return localISOTime;
    }
    const navigate = useNavigate();
    useEffect(() => {
        fetchData()
        getCurrency()
    }, [])

    const [formData, setFormData] = useState({
        InvoiceNO: "",
        remarks: "",
        InvoiceDate: moment().format("YYYY-MM-DD"),          // Today's date
        deliveryDate: moment().format("YYYY-MM-DD"),
        DueDate: moment().format("YYYY-MM-DD"),
        PaymentTerm: "",
        POType: "",
        SuppInvoiceNo: "",
        Department: "",
        Currency: "",
        exchangeRate: "",
        TaxInvoice: "",
        CostCentre5: "",
        Narration: "",
        costCenter1: "",
        costCenter2: "",
        costCenter3: "",
        costCenter4: "",
    })

    const fetchData = async () => {
        setLoading(true)
        setInvoiceNo(itemData?.invoiceRegNo)
        const response = await apiService.get("GET_PO_INVOICE");
        setPurchaseOrder(response.data.result);
        let cost1 = await apiService.get('GET_COST_ONE')
        setCost1(cost1?.data?.result)
        let cost2 = await apiService.get('GET_COST_TWO')
        setCost2(cost2?.data?.result)
        let cost3 = await apiService.get('GET_COST_THREE')
        setCost3(cost3?.data?.result)
        let cost4 = await apiService.get('GET_COST_FOUR')
        setCost4(cost4?.data?.result)
        let InvData = itemData

        let param = `?Id=${InvData?.pOrderNo}`
        const selectedPO = await apiService.getApiParamater("GET_PO", param);
        let selectedpurchase = selectedPO?.data?.result[0]

        if (selectedpurchase) {
            setLoading(false)
            setSelectedPO({ label: selectedpurchase?.pOrderNo, value: selectedpurchase?.pOrderNo })
            setSelectedSupplier({ label: selectedpurchase?.vendorName, value: selectedpurchase })
            setFormData({
                deliveryDate: new Date(selectedpurchase?.docDate),
                DueDate: itemData?.dueDate ? new Date(itemData?.dueDate) : moment().format("YYYY-MM-DD"),
                InvoiceDate: itemData?.invoiceDate,
                PaymentTerm: selectedpurchase?.terms,
                SuppInvoiceNo: itemData?.invoiceNo,
                Narration: itemData?.remarks,
                POType: selectedpurchase?.docId || "",
                costCenter1: { label: selectedpurchase?.costCenter1 || '', value: selectedpurchase?.costCenter1 || '' },
                costCenter2: { label: selectedpurchase?.costCenter2 || '', value: selectedpurchase?.costCenter2 || '' },
                costCenter3: { label: selectedpurchase?.costCenter3 || '', value: selectedpurchase?.costCenter3 || '' },
                costCenter4: { label: selectedpurchase?.costCenter4 || '', value: selectedpurchase?.costCenter4 || '' },
            });
            setLoading(false)
            setPOData(selectedpurchase)
        }
    }
    const fetchItemsData = async (grnList) => {
        const selectedGrns = grnList.filter(grn => grn.checked === 1);
        let combinedGrn = {
            recordIds: [],
            requisitionDate: todayDate,
            invoiceNos: [],
            contractNos: [],
            remarks: [],
            requestors: [],
            currencyCodes: [],
            costCenters2: [],
            costCenters3: [],
            costCenters4: [],
            deliveryPoints: [],
            contactPersons: [],
            contactNos: [],
            taskCodes: [],
            locations: [],
            grnDetails: []
        };

        for (const selectedGrn of selectedGrns) {
            let param = `?Id=${selectedGrn?.grnNo}`
            const grnList = await apiService.getApiParamater("GET_GRN", param);
            setGrnList(grnList?.data?.result);
            let grnData = grnList?.data?.result[0]

            if (grnData) {
                combinedGrn.recordIds.push(grnData.grnNo);
                combinedGrn.invoiceNos.push(grnData.invoiceNo);
                combinedGrn.contractNos.push(grnData.contractNo);
                combinedGrn.remarks.push(grnData.remarks);
                combinedGrn.requestors.push(grnData.requestor);
                combinedGrn.currencyCodes.push(grnData.currencyCode);
                combinedGrn.costCenters2.push(grnData.costCenter2);
                combinedGrn.costCenters3.push(grnData.costCenter3);
                combinedGrn.costCenters4.push(grnData.costCenter4);
                combinedGrn.deliveryPoints.push(grnData.deliveryPoint);
                combinedGrn.contactPersons.push(grnData.contactPerson);
                combinedGrn.contactNos.push(grnData.contatNo);
                combinedGrn.taskCodes.push(grnData.projectCode);
                combinedGrn.locations.push(grnData.warehouse);
                combinedGrn.grnDetails = [...combinedGrn.grnDetails, ...grnData.grnDetails];
            }
        }

        setSelectedGrn(selectedGrns || []);
        setFormData({
            ...formData,
            recordIds: combinedGrn.recordIds.join(', '),
            invoiceNo: combinedGrn.invoiceNos.join(', '),
            contractNo: combinedGrn.contractNos.join(', '),
            remarks: combinedGrn.remarks.join(', '),
            requestor: combinedGrn.requestors.join(', '),
            currencyCode: combinedGrn.currencyCodes.join(', '),
            costCenter2: combinedGrn.costCenters2.join(', '),
            costCenter3: combinedGrn.costCenters3.join(', '),
            costCenter4: combinedGrn.costCenters4.join(', '),
            deliveryPoint: combinedGrn.deliveryPoints.join(', '),
            contactPerson: combinedGrn.contactPersons.join(', '),
            contactNo: combinedGrn.contactNos.join(', '),
            taskCode: combinedGrn.taskCodes.join(', '),
            location: combinedGrn.locations.join(', '),

        });

        if (combinedGrn.grnDetails.length === 0) {
            setGrnItems();
        } else {
            setGrnItems(combinedGrn.grnDetails || []);
        }

    }
    const GenerateNumber = async () => {
        let docParam = `?TypeOfDoc=INV&DocId=Invoice`
        const DocId = await apiService.getApiParamater("GET_DOC_ID", docParam);
        setInvoiceNo(DocId?.data.result[0].docId);
        onCloseModal()
    }
    const getCurrency = async () => {

        const currencylist = JSON.parse(localStorage.getItem('currencylist')) || [];
        const newDefaultCurrency = currencylist?.find((comp) => comp.isDefault === true);
        setSelectedCurency({ label: newDefaultCurrency.code, value: newDefaultCurrency });
        setFormData({ ...formData, exchangeRate: newDefaultCurrency.conversionRate });
    }
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    }
    const handleMessage = (data) => {
        setMessageData(data);
        console.log(data, 'reqData')

    }
    const handleRequisitionData = (data) => {
        setItemData(data);
        console.log(data, 'reqData')
    }
    const GrnData = (data) => {
        setGrnData(data);
        fetchItemsData(data)
        console.log(data, 'grnData')
    }
    const handleAuthorization = (data) => {
        setAuthorizationData(data);
        console.log(data, 'reqData')

    }

    const CreateInvoice = async () => {
        setLoader(true)

        if (!SelectedPO?.label) {
            toast.warning("Please enter Purchase Order No.");
            setLoader(false)
            return;
        }
        if (selectedGrn?.length === 0) {

            toast.warning("Please Select Grn For Invoice Creation");
            setLoader(false)
            return;
        }
        if (ItemData?.length === 0) {
            toast.warning("Please add items");
            setLoader(false)
            return;
        }
        if (!formData?.SuppInvoiceNo) {
            toast.warning("Please enter Supp Invoice No");
            setLoader(false)
            return;
        }
        if (!formData?.InvoiceDate) {
            toast.warning("Please enter Supp Invoice Date");
            setLoader(false)
            return;
        }
        try {
            const currentDatetimeUTC = new Date().toISOString();
            const apiService = new ApiService();
            const totalAmount = ItemData.reduce((sum, row) => sum + (row?.amount || 0), 0);

            const invoiceRegDetails = ItemData?.map((item, index) => {
                const selectedGrn = grnData?.find(rec => rec.grnNo === item.grnNo);

                let amount = (item?.qty * item?.unitPrice)
                let afterdiscount = (amount - item?.discount)
                let vat = (afterdiscount * item.vat) / 100
                let total = (afterdiscount + vat)

                return {
                    itemCode: item?.ItemNo,
                    itemDescription: item.itemDescription,
                    uom: item.uom,
                    qty: parseFloat(item.qty),
                    baseUOM: item?.uom,
                    baseQty: item.qty,
                    budgetCode: '',
                    specification: item.specification,
                    unitPrice: Number(item?.unitPrice?.toFixed(4)),
                    amount: Number(item?.amount?.toFixed(3)),
                    baseAmount: (parseFloat(afterdiscount) - parseFloat(item?.vatAmount))?.toFixed(3),
                    vatAmount: Number(item?.vatAmount),
                    discount: Number(item?.discount),
                    baseDiscount: Number(item?.discount),
                    convToInvUOM: item.stock,
                    isActive: true,
                    srno: item?.srno,
                    vatPerc: item.vat,
                    grnNo: item?.grnNo,
                };
            }).filter(item => item);

            const body = {
                rcNo: itemData?.rcNo,
                // attention: "string",
                // fax: "string",
                // quotationRef: "string",
                // contractNo: "string",
                // deliveryPoint: "string",
                // contactPerson: "string",
                // state: "string",
                // diffAmount: 0,
                // grnNo: "string",
                // batchNo: "string",
                // nvType: "string",
                // diffAcCode: "string",

                invoiceNo: formData?.SuppInvoiceNo,
                invoiceRegNo: invoiceNo,
                // invoiceRef: formData?.SuppInvoiceNo,
                invoiceDate: formData?.InvoiceDate || currentDatetimeUTC,
                pOrderNo: SelectedPO.label,
                vendorId: SelectedSupplier?.value?.vendorId,
                vendorName: SelectedSupplier.label,
                docDate: formData?.InvoiceDate || currentDatetimeUTC,
                location: formData?.location,
                costCenter1: formData?.costCenter1?.label,
                costCenter2: formData?.costCenter2?.label,
                costCenter3: formData?.costCenter3?.label,
                costCenter4: formData?.costCenter4?.label,
                costCenter5: formData.TaxInvoice,
                currencyCode: SelectedCurrency.label,
                exchangeRate: SelectedCurrency?.value.conversionRate,
                terms: SelectedSupplier?.value?.terms,
                department: SelectedSupplier?.value?.department,
                aprrovalUser: authorizationData?.userNo,
                modifiedOn: currentDatetimeUTC,
                modifiedBy: userName,
                status: 0,
                remarks: formData.Narration,
                dueDate: currentDatetimeUTC,
                isActive: true,
                isEditable: 0,
                invoiceRegDetails: invoiceRegDetails,
                baseAmount: Number(totalAmount).toFixed(currencyPrecision || 3),
                amount: Number(totalAmount).toFixed(currencyPrecision || 3),
            };

            const response = await apiService.put("UPDATE_INVOICE", body);
            if (response?.data?.statusCode === 201) {
                const userData2 = {
                    docType: "Invoice",
                    docId: invoiceNo,
                    department: "IT",
                    company: Company?.selectedCompany?.companyNo,
                    userCode: userId,
                    userName: userName,
                };
                if (attachments) {
                    let name = "Invoice"
                    let docNo = invoiceNo
                    handleUpload(name, docNo)
                }
                const response2 = await apiService.post("CREATE_DOC_AUTHORIZATION", userData2);
                setLoader(false)
                toast.success(`${invoiceNo} Updated successfully`);
                navigate("/Inventory/invoice/List");
            } else if (response?.data?.statusCode === 208) {
                setLoader(false)
                onOpenModal()
            }
        } catch (error) {
            setLoader(false)
            console.error("Error Creating issue:", error);
        }
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'deliveryDate' || name === 'InvoiceDate' || name === 'DueDate') {
            const dateParts = e.target.value.split("-");
            if (dateParts[0].length > 4) {
                return;
            }
        }
        setFormData({ ...formData, [e.target.name]: e.target.value });
    }
    const handlePoChange = async (selectedOption) => {
        let param = `?Id=${selectedOption?.label}`
        const selectedPO = await apiService.getApiParamater("GET_PO", param);
        let selectedpurchase = selectedPO?.data?.result[0]

        if (selectedpurchase) {
            setOverallDiscount(parseFloat(selectedpurchase?.discountPerc) || 0);
            setSelectedPO({ label: selectedpurchase?.pOrderNo, value: selectedpurchase?.pOrderNo })
            setSelectedSupplier({ label: selectedpurchase?.vendorName, value: selectedpurchase })
            setFormData({ ...formData, PurchaseOrderDate: selectedpurchase?.docDate });
            setFormData({ ...formData, PaymentTerm: selectedpurchase?.terms })

            setFormData({
                PurchaseOrderDate: selectedpurchase?.docDate,
                PaymentTerm: selectedpurchase?.terms,
                costCenter1: { label: selectedpurchase?.costCenter1 || '', value: selectedpurchase?.costCenter1 || '' },
                costCenter2: { label: selectedpurchase?.costCenter2 || '', value: selectedpurchase?.costCenter2 || '' },
                costCenter3: { label: selectedpurchase?.costCenter3 || '', value: selectedpurchase?.costCenter3 || '' },
                costCenter4: { label: selectedpurchase?.costCenter4 || '', value: selectedpurchase?.costCenter4 || '' },
            });
            setPOData(selectedpurchase)
        }
    }
    const handleBackClick = () => {
        window.history.back();
    }
    const handleCost1 = (selectedOption) => {
        setFormData({ ...formData, costCenter1: selectedOption });
    }
    const handleCost2 = (selectedOption) => {
        setFormData({ ...formData, costCenter2: selectedOption });
    }
    const handleCost3 = (selectedOption) => {
        setFormData({ ...formData, costCenter3: selectedOption });
    }
    const handleCost4 = (selectedOption) => {
        setFormData({ ...formData, costCenter4: selectedOption });
    }
    // Attachment Functions
    const handleFileSelect = useCallback((file, id) => {
        setAttachments((prev) => {
            const updated = prev.map((row) =>
                row.id === id ? { ...row, file, fileName: file.name } : row
            );
            return [...updated, createEmptyRow()];
        });
    }, []);
    const handleRemarkChange = (id, value) => {
        setAttachments((prev) =>
            prev.map((row) =>
                row.id === id ? { ...row, remarks: value } : row
            )
        );
    };

    const handleDelete = (id) => {
        setAttachments((prev) => prev.filter((row) => row.id !== id));
    };

    const handleView = (file) => {
        if (!file) return;
        if (isReadOnly) {
            setPreviewImage(file);
        } else {
            setPreviewImage(URL.createObjectURL(file));
        }
        setPreviewModal(true);
    };
    const handleUpload = async (name, docNo) => {
        const formData = new FormData();

        attachments.forEach(({ file }) => {
            if (file instanceof File) {
                formData.append("Images", file, file.name);
            }
        });

        const response = await apiService.postMultiPart(
            "UPLOAD_FILE",
            formData
        );

        if (response?.data?.statusCode === 201 && response?.data?.isSuccessful) {
            const uploadedFileNames = response.data.result.split(",");

            const payload = {
                docFilesDtos: attachments
                    .filter((a) => a.file)
                    .map((a, index) => ({
                        srno: index + 1,
                        docNo: docNo,
                        docType: name,
                        fileName: uploadedFileNames[index]?.trim(),
                        remarks: a.remarks || "",
                    })),
            };

            await apiService.post("CREATE_ATTACHMENT", payload);
            return
        }
    };
    return (
        <div className='px-4'>
            {loading && (
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        background: 'rgba(255,255,255,0.6)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10,
                    }}
                >
                    <div className="spinner-border text-primary" role="status" />
                </div>
            )}
            <div className='d-flex justify-content-between pt-3'>
                <h5 className='col mainInvHead'>Supplier Invoice</h5>
                <div className='d-flex gap-3'>
                    {loader === true ?
                        <button className='mainbtn ' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
                        <button className='mainbtn ' type="submit" onClick={CreateInvoice}><FaSave className='center mt-1 mx-2' /><div>Save</div></button>
                    }
                    <button className='mainbtnRed' ><RiRefreshLine className='center mt-1 mx-2' /><div>Reset</div></button>
                    <button onClick={handleBackClick} className='mainbtnSecondary'><FaAngleLeft className='center mt-1 mx-2' /><div>Back</div></button>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setPOTab(!POTab)}>
                    <div className='h6 pt-1'>Invoice Details</div>
                </div>
                <div className={`slide-content ${POTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${POTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="form-group row pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="InvoiceNO" className="form-label  pt-1 start">Invoice No</label>
                                <input
                                    className="form-Input w-100"
                                    id="invoiceNo"
                                    value={invoiceNo}
                                    name="invoiceNo"
                                    disabled
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="deliveryDate" className="form-label  pt-1 start">Date </label>
                                <DatePicker
                                    selected={formData.deliveryDate}
                                    onChange={(date) =>
                                        setFormData({
                                            ...formData,
                                            deliveryDate: date,
                                        })
                                    }
                                    className="p-2 form-Input w-100"
                                    dateFormat="dd-MM-yyyy"
                                    todayButton="Today"
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="POType" className="form-label  pt-1 start">PO Type</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    value={formData.POType} disabled
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="InvoiceDate" className="form-label  pt-1 start">Supp. Invoice Date</label>
                                <DatePicker
                                    selected={formData.InvoiceDate}
                                    onChange={(date) =>
                                        setFormData({
                                            ...formData,
                                            InvoiceDate: date,
                                        })
                                    }
                                    className="p-2 form-Input w-100"
                                    dateFormat="dd-MM-yyyy"
                                    todayButton="Today"
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-1 start">Supplier Name</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0"
                                    value={SelectedSupplier}
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="PaymentTerm" className="form-label  pt-1 start">Payment Term</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    id="PaymentTerm"
                                    value={formData.PaymentTerm}
                                    onChange={handleInputChange}
                                    name="PaymentTerm"
                                />
                            </div>
                        </div>
                        <div className="form-group row  pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-1 start">Purchase Order No *</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0" isDisabled
                                    value={SelectedPO}
                                    options={PurchaseOrder?.map((po) => ({ value: po?.pOrderNo, label: po?.pOrderNo }))}
                                    onChange={(selectedOption) => handlePoChange(selectedOption)}
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="SuppInvoiceNo" className="form-label  pt-1 start">Supp. Invoice No</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    id="SuppInvoiceNo"
                                    value={formData.SuppInvoiceNo}
                                    onChange={handleInputChange}
                                    name="SuppInvoiceNo"
                                />
                            </div>
                            {/* <div className="d-flex justify-content-between col">
                                <label htmlFor="DueDate" className="form-label  pt-1 start">Due Date</label>
                                <DatePicker
                                    selected={formData.DueDate}
                                    onChange={(date) =>
                                        setFormData({
                                            ...formData,
                                            DueDate: date,
                                        })
                                    }
                                    className="p-2 form-Input w-100"
                                    dateFormat="dd-MM-yyyy"
                                    todayButton="Today"
                                />
                            </div> */}
                            <div className="d-flex justify-content-between col-4">
                                <label htmlFor="Narration" className="form-label  pt-1 start">Narration</label>
                                <input
                                    type="text" onWheel={(e) => e.target.blur()}
                                    className="form-Input w-100"
                                    id="Narration"
                                    value={formData.Narration}
                                    onChange={handleInputChange}
                                    name="Narration"
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="TaxInvoice" className="form-label  pt-1 start">Tax Invoice No  (KRA)</label>
                                <input
                                    type="number" onWheel={(e) => e.target.blur()}
                                    className="form-Input w-100"
                                    id="TaxInvoice"
                                    value={formData.TaxInvoice}
                                    onChange={handleInputChange}
                                    name="TaxInvoice"
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="Currency" className="form-label  pt-1 start">Currency</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0"
                                    isSearchable={false}
                                    value={SelectedCurrency}
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="EXRate" className="form-label  pt-1 start">EX Rate</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    disabled
                                    onWheel={(e) => e.target.blur()}
                                    id="exchangeRate"
                                    value={formData.exchangeRate}
                                    onChange={handleInputChange}
                                    name="exchangeRate"
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <div className='col-1 px-5 mx-3'></div>
                            <div className="col-2 brderbox center" onClick={() => handleOpen()} >
                                {'Attachment'}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setSupplierTab(!SupplierTab)}>
                    <div className='h6 pt-1'>GRN Details</div>
                </div>
                <div className={`slide-content ${SupplierTab ? 'open' : 'closed'}`}>
                    <div className="border-box2">
                        <div className="grid-1">
                            <InvoiceGrnList GrnData={GrnData} SelectedPO={SelectedPO.value} itemData={itemData} currencyPrecision={currencyPrecision?.exp1 || 3} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setCostTab(!CostTab)}>
                    <div className="h6 pt-1">Cost Center Details</div>
                </div>
                <div className={`slide-content ${CostTab ? 'open' : 'closed'}`}>
                    <div className="border-box2 p-3">
                        <div className="form-group row pb-3">
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="PropertyGroup" className="form-label  pt-1 start">Property</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0"
                                    value={formData.costCenter1}
                                    onChange={handleCost1}
                                    options={cost1?.map((sup) => ({ value: sup, label: sup?.description }))}
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="Property" className="form-label  pt-1 start">Unit</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0" value={formData.costCenter2}
                                    onChange={handleCost2}
                                    options={cost2?.map((sup) => ({ value: sup, label: sup?.description }))}
                                />
                            </div>
                            <div className="d-flex justify-content-between col">
                                <label htmlFor="Department" className="form-label  pt-1 start">Cost Center 3</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0" value={formData.costCenter3}
                                    onChange={handleCost3}
                                    options={cost3?.map((sup) => ({ value: sup, label: sup?.description }))}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <div className="d-flex justify-content-between col-4">
                                <label htmlFor="Outlet" className="form-label  pt-1 start">Cost Center 4</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0" value={formData.costCenter4}
                                    onChange={handleCost4}
                                    options={cost4?.map((sup) => ({ value: sup, label: sup?.description }))}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div className="slide-container p-2 mt-3">
                <div className="container-fluid">
                    <div className="nav nav-pills overslid d-flex gap-4">
                        {/* Nav tabs */}
                        <div
                            className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(0)}
                        >
                            Items
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(1)}
                        >
                            Authorization
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(2)}
                        >
                            Message
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid-1 brderbox2 p-4 mb-3">
                {gridVisibility[0] && (
                    <InvoiceItemList onRequisitionData={handleRequisitionData} GrnItemData={GrnItemData} currencyPrecision={currencyPrecision?.exp1 || 3} SelectedPO={SelectedPO}
                        setOverallDiscount={setOverallDiscount} overallDiscount={overallDiscount} setDiscountAmount={setDiscountAmount}
                        discountAmount={discountAmount} setGrandTotal={setGrandTotal} grandTotal={grandTotal}
                        vatAmount={vatAmount} setVatAmount={setVatAmount} />
                )}
                {gridVisibility[1] && (
                    <AuthorizationInvoice handleAuthorization={handleAuthorization}
                        usersDetails={usersDetails}
                        setUser={setUser}
                        itemData={POData} />
                )}
                {gridVisibility[2] && (
                    <div className="grid-3 border">
                        {/* <MessageGrid handleMessage={handleMessage} /> */}
                    </div>
                )}
            </div>
            <div>
                <Attachment
                    open={attachmentModal}
                    onClose={closeModal}
                    documentNo={invoiceNo}
                    rows={attachments}
                    readOnly={isReadOnly}
                    onFileSelect={handleFileSelect}
                    onRemarkChange={handleRemarkChange}
                    onDelete={handleDelete}
                    onView={handleView}
                    onSave={handleUpload}
                    previewImage={previewImage}
                    previewOpen={previewModal}
                    closePreview={() => setPreviewModal(false)}
                />
            </div>
            <Modal size="md"
                show={docModal} onHide={() => setDocModal(false)}
                backdrop="static"
                contentLabel='Doc Id Modal'
            >
                <Modal.Header closeButton>
                    <Modal.Title className="center">Invoice Number</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="text-danger">
                        The Invoice number already exists. Click "Generate" to assign a new number.
                    </p>
                </Modal.Body>
                <Modal.Footer className='end p-3'>
                    <button className='mainbtnGry' onClick={onCloseModal}>Cancel</button>
                    <button className='mainbtnRed' onClick={GenerateNumber}>Generate</button>
                </Modal.Footer>
            </Modal>
        </div >
    )
}

export default UpdateInvoice